import type { AutocompleteResult } from '@common/types/AutocompleteResult'
import type { Children } from '@lc/libreact'
import { createContext, useMemo, useState } from 'react'

export type ModuleActionsSearch = {
	path: string
	acceptSearch: (result: AutocompleteResult) => void
	clearSearch: () => void
}

export type SearchBarActionsSearch = {
	clearSearch: () => void
}

export type SetSearch = {
	setModule: (module: ModuleActionsSearch | null) => void
	setSearch: (search: SearchBarActionsSearch | null) => void
	setResult: (result: AutocompleteResult | null) => void
}

// eslint-disable-next-line react-refresh/only-export-components
export const ModuleActionsSearchContext =
	createContext<ModuleActionsSearch | null>(null)
// eslint-disable-next-line react-refresh/only-export-components
export const SearchBarActionsSearchContext =
	createContext<SearchBarActionsSearch | null>(null)
// eslint-disable-next-line react-refresh/only-export-components
export const SearchResultSearchContext =
	createContext<AutocompleteResult | null>(null)
// eslint-disable-next-line react-refresh/only-export-components
export const SetSearchContext = createContext<SetSearch | null>(null)

export function SearchProvider({ children }: { children: Children }) {
	const [module, setModule] = useState<ModuleActionsSearch | null>(null)
	const [search, setSearch] = useState<SearchBarActionsSearch | null>(null)
	const [result, setResult] = useState<AutocompleteResult | null>(null)

	const set = useMemo(() => ({ setModule, setSearch, setResult }), [])

	return (
		<SetSearchContext value={set}>
			<SearchBarActionsSearchContext value={search}>
				<ModuleActionsSearchContext value={module}>
					<SearchResultSearchContext value={result}>
						{children}
					</SearchResultSearchContext>
				</ModuleActionsSearchContext>
			</SearchBarActionsSearchContext>
		</SetSearchContext>
	)
}
